import React from 'react'
import { useTranslation } from 'react-i18next'
import messageUtil from 'utils/messageUtil'
import { InsightContentSettingType } from 'components/insightContent/types'
import { useMeasureWithInsightCount } from 'components/insightContent/hooks'
import { getPercentOfTotal } from 'components/insightContent/utils/utils'
import { PercentDisplay } from 'components/insightContent/visualization/Overview'
import { CountTypeStrings } from 'enums/CountType'

import SingleMeasure from '../SingleMeasure'
import Title from './Title'

const NameMeasureWithShareOfInsights = ({
  detailSetting,
  countType,
  renderTitleContent
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  renderTitleContent?: () => React.ReactNode
}) => {
  const { t } = useTranslation()
  const measureWithInsightCount = useMeasureWithInsightCount()

  const customizedInfoDisplay = (value: number, displayedCount: string) => {
    const insightPercent = getPercentOfTotal(value, measureWithInsightCount)

    return (
      <PercentDisplay
        count={displayedCount}
        sideLabel={
          insightPercent &&
          t('percentOfCountTypeWithViewOption', {
            insightPercent,
            countType: messageUtil.countType(countType).toLowerCase(),
            viewOption: messageUtil.viewOption(detailSetting.viewOption),
            interpolation: { escapeValue: false }
          })
        }
      />
    )
  }

  return (
    <SingleMeasure
      detailSetting={detailSetting}
      countType={countType}
      customizedInfoDisplay={customizedInfoDisplay}>
      <Title
        countType={countType}
        selectionName={detailSetting.selectionName}
        renderContent={renderTitleContent}
      />
    </SingleMeasure>
  )
}

export default NameMeasureWithShareOfInsights
